export const triggerClick = ({ id, delay = 0 }) => {
  setTimeout(() => {
    const element = document.getElementById(id);
    if (element) {
      element.click();
    }
  }, delay);
};
